import { Link } from 'react-router-dom';
import { latestNews } from '@/mocks/home';

export default function NewsSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100/70">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 gap-4">
          <div>
            <span className="text-xs font-bold text-primary-500 uppercase tracking-wider">News</span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mt-2">
              体育资讯
            </h2>
          </div>
          <Link
            to="/category/news"
            className="flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {latestNews.slice(0, 1).map((news) => (
            <Link
              key={news.id}
              to={`/article/${news.id}`}
              className="group relative rounded-xl overflow-hidden cursor-pointer"
            >
              <div className="aspect-[16/10] w-full">
                <img src={news.image} alt={news.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <span className="text-[10px] font-bold text-accent-500 bg-background-50/90 px-2.5 py-1 rounded-full">
                  {news.category}
                </span>
                <h3 className="font-bold text-background-50 text-lg md:text-xl mt-3 leading-snug group-hover:text-accent-300 transition-colors">
                  {news.title}
                </h3>
                <div className="flex items-center gap-3 mt-3 text-xs text-background-50/60">
                  <span>{news.date}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line text-xs"></i> {(news.views / 10000).toFixed(1)}万
                  </span>
                </div>
              </div>
            </Link>
          ))}

          <div className="flex flex-col gap-4">
            {latestNews.slice(1).map((news) => (
              <Link
                key={news.id}
                to={`/article/${news.id}`}
                className="group flex gap-4 bg-background-50 rounded-xl p-4 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="w-28 h-20 md:w-36 md:h-24 rounded-lg overflow-hidden flex-shrink-0">
                  <img src={news.image} alt={news.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="flex-1 min-w-0 flex flex-col justify-between">
                  <div>
                    <span className="text-[10px] font-bold text-accent-500 bg-accent-50 px-2 py-0.5 rounded-full">
                      {news.category}
                    </span>
                    <h4 className="font-bold text-foreground-900 text-sm mt-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
                      {news.title}
                    </h4>
                  </div>
                  <div className="flex items-center gap-3 text-xs text-foreground-400">
                    <span>{news.date}</span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line text-xs"></i> {(news.views / 10000).toFixed(1)}万
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}